import {Component, Inject, OnInit} from '@angular/core';
import {LoadingService} from '../../services/loading.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
  templateUrl: './error-dialog.component.html'
})
export class ErrorDialogComponent implements OnInit {
  public mode: string;
  public message: string;

  constructor(private loadingService: LoadingService,
              private matDialogRef: MatDialogRef<ErrorDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.loadingService.hide();
    this.mode = this.data.mode;
    this.message = `Παρουσιάστηκε κάποιο πρόβλημα κατά την εκτέλεση κάποιας διεργάσιας του συστήματος.`;
  }

  public ngOnInit(): void {
    this.matDialogRef.updateSize('600px');
    this.matDialogRef.disableClose = true;
  }

  public closeDialog(): void {
    this.matDialogRef.close();

    if (this.mode === 'global') {
      window.location.reload();
    }
  }
}
